var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});

function createSchema(schema) {
  return schema;
}

exports.createSchema = createSchema;
export default exports;